import PropTypes from 'prop-types';
import React from 'react';
import BasicDownload from '../core/BasicDownload';
import ExportAndDownload from '../core/ExportAndDownload';

class OntologyExport extends React.Component {

    render() {

        return (
            <ExportAndDownload>
                <BasicDownload
                    resource={this.props.id}
                    graph={this.props.graph}
                    exportName="ontologyexport"
                    message="Export the ontology, with some system data retained, such as revision numbers." />
                <BasicDownload
                    resource={this.props.id}
                    dataTest="clean-data-download"
                    graph={this.props.graph}
                    title="Clean Download"
                    exportName="ontologycleanexport"
                    message="Export the ontology, with any system data removed. Use this option if you want a clean export." />
            </ExportAndDownload>
        );
    }
}

OntologyExport.propTypes = {
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired
};

export default OntologyExport;